import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';

import {
  COMPANY_DETAILS_COMPANY_DATA_CARD,
  COMPANY_VINDAT_RELATION_OPTIONS,
  COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  COMPANY_VINDAT_LEGAL_OPTIONS,
} from '../../Companies/constants';
import { getPropByName } from '../../../utils/props';
import { COLOR_PRIMARY_1 } from '../../../vars';

import { selectConfig } from '../../Api/selectors';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import styles from './CardClientDetails.module.css';
import cn from 'classnames';

const Container = styled.div`
  font-size: 12px;

  .cardHeader {
    margin-bottom: 20px;
  }
  .card-title {
    white-space: nowrap;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }
  .icon-edit-square {
    color: #d9d9d9;
  }

  input {
    width: 100%;
  }

  .row-input {
    .col-1 {
      flex-basis: 25%;
      margin-right: 5px;
    }
    .col-2 {
      flex-basis: 57%;
    }
  }

  .dropdown-wrapper {
    .dropdown-card {
      height: 35px;
    }
  }

  .link-wrap {
    cursor: pointer;
    &:hover {
      color: ${COLOR_PRIMARY_1};
    }
  }
`;

const DROPDOWN_OPTIONS = {
  company_from_eu: ['NL', 'EU', 'OUTSIDE_EU'],
  ORB_TDN_preference: ['ORB', 'TDN'],
  Vindat_Relation: COMPANY_VINDAT_RELATION_OPTIONS,
  Vindat_Franchisefomule: COMPANY_VINDAT_FRANCHISEFOMULE_OPTIONS,
  vindat_legal_form: COMPANY_VINDAT_LEGAL_OPTIONS,
};

const STATE = {
  isEditCompany: false,
};
/* eslint-disable react/prefer-stateless-function */
class TransportOrderClientCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    COMPANY_DETAILS_COMPANY_DATA_CARD.map(property => {
      if (this.props.companyTo[property]) {
        this.setState({ [property]: this.props.companyTo[property] });
      }
    });
    if (this.props.companyTo?.country_code) {
      this.setState({ country_code: this.props.companyTo?.country_code });
    }
  }

  checkbox(type, label) {
    return <CheckboxComponent label={label} checked={this.state[type] == '1'} />;
  }

  isShowPropertyCell(type) {
    if (this.props.companyTo[type]) {
      return true;
    }
    return false;
  }

  windowOpen(url, name, specs) {
    if (!url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    return window.open(url);
  }

  rows(company) {
    return COMPANY_DETAILS_COMPANY_DATA_CARD;
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    const company = this.props.companyTo;
    const address = company.addresses?.find(a => a.type?.name === 'home');
    const accountManager = company.accountManager;
    return (
      <Card className="company-info-card info-card data">
        <Container className="cardHeader">
          <HBox className="align-items-center">
            <h2 className="card-title m-0">{this.lbl('company.info.data.client_info_to')}</h2>
          </HBox>

          <>
            {this.rows().map(property => {
              if (property == 'name') {
                return (
                  this.isShowPropertyCell(property) && (
                    <>
                      <div className={styles.containerLabel} key={property}>
                        <div className={styles.formField}>
                          <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                          <div className={styles.labelTable}>
                            {company['company_type'] == 'company'
                              ? `${company['name'] || ''}`
                              : `${company[property] || ''} ${company['surname'] ? company['surname'] : ''}`}
                          </div>
                        </div>
                      </div>
                    </>
                  )
                );
              }

              if (property == 'headquarters') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    {this.checkbox(property, this.lbl(`company.property.${property}`))}
                  </div>
                );
              }

              if (property == 'company_from_eu') {
                return (
                  this.isShowPropertyCell && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {this.lbl(`company.property.${property}.${company.company_from_eu || 'OUTSIDE_EU'}`)}
                        </div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'address') {
                return (
                  address && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {!address ? '' : address.addressLine1 + ' ' + address.postcode + ' ' + address.city}
                        </div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'phone_number') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          {`${company['country_code'] ? `+${company['country_code']}` : ''} ${company[property] ||
                            company['telephonenr']}`}
                        </div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'email') {
                return (
                  company['company_type'] !== 'company' &&
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }
              if (property == 'company_email') {
                return (
                  company['company_type'] == 'company' &&
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'website') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>
                          <div className="link-wrap" onClick={() => this.windowOpen(company[property])}>
                            {company[property]}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'account_manager') {
                return (
                  accountManager && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{`${getPropByName(accountManager, 'name') || ''} ${getPropByName(
                          accountManager,
                          'surname',
                        ) || ''}`}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'ORB_TDN_preference') {
                return (
                  this.isShowPropertyCell(property) && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'RDW_number') {
                return this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' &&
                  company['company_from_eu'] == 'NL' ? (
                  <div className={styles.containerLabel} key={property}>
                    <div className={styles.formField}>
                      <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                      <div className={styles.labelTable}>{company[property]}</div>
                    </div>
                  </div>
                ) : (
                  ''
                );
              }
              //
              if (property == 'Vindat_Relation') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'Vindat_Franchisefomule') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'vindat_legal_form') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'Vindat_Relation') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'vindat_valuation_center') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'in_the_wallet') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }
              if (property == 'ORB_TDN_preference') {
                return (
                  this.isShowPropertyCell(property) &&
                  company['company_type'] == 'company' && (
                    <div className={styles.containerLabel} key={property}>
                      <div className={styles.formField}>
                        <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                        <div className={styles.labelTable}>{company[property]}</div>
                      </div>
                    </div>
                  )
                );
              }

              if (property == 'createdAt') {
                return (
                  <div className={styles.containerLabel} key={property}>
                    <div className={styles.formField}>
                      <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                      <div className={styles.labelTable}>{dayjs(company[property]).format('DD-MM-YYYY')}</div>
                    </div>
                  </div>
                );
              }
              return (
                this.isShowPropertyCell(property) && (
                  <div className={styles.containerLabel} key={property}>
                    <div className={styles.formField}>
                      <div className={styles.textContainer}>{this.lbl(`company.property.${property}`)}</div>
                      <div className={styles.labelTable}>
                        {this.lbl(`company.property.${property}.${company[property]}`)}
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </>
        </Container>
      </Card>
    );
  }
}

TransportOrderClientCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderClientCard = compose(withConnect, withRouter)(TransportOrderClientCardComp);
